module.exports = __webpack_public_path__ + "static/media/Logo.0f4739eb.PNG";